(function(){
  var root = document.querySelector('.pv-cr');
  if(!root) return;
  var grid = root.querySelector('#pv-grid');
  if(!grid) return;

  var cards   = [].slice.call(grid.querySelectorAll('.pv-post'));
  var chips   = [].slice.call(root.querySelectorAll('.pv-chip'));
  var moreWrap= root.querySelector('#pv-more');
  var moreBtn = root.querySelector('#pv-more-btn');
  var moreTxt = root.querySelector('#pv-more-count');
  var batch   = parseInt(grid.getAttribute('data-batch'),10) || 12;
  var active  = 'all';
  var shown   = batch;

  function matches(card){
    if(active === 'all') return true;
    var t = (card.getAttribute('data-pv-tags') || '').split(/\s+/);
    return t.indexOf(active) > -1;
  }

  function paint(){
    var n = 0, total = 0;
    cards.forEach(function(c){
      if(!matches(c)){ c.hidden = true; return; }
      total++;
      if(n < shown){ c.hidden = false; n++; } else { c.hidden = true; }
    });
    if(moreWrap){
      if(total > n){
        moreWrap.hidden = false;
        if(moreTxt) moreTxt.textContent = n + ' of ' + total + ' showing';
      } else {
        moreWrap.hidden = true;
        if(moreTxt) moreTxt.textContent = '';
      }
    }
    var empty = root.querySelector('#pv-empty');
    if(empty) empty.hidden = total > 0;
  }

  if(moreBtn){
    moreBtn.addEventListener('click', function(){
      shown += batch;
      paint();
      if(moreWrap && moreWrap.hidden === false && moreTxt){ moreBtn.focus(); }
    });
  }

  /* Chips are real /tagged/ links so they work without JS.
     With JS we intercept for instant filtering and keep the URL in step. */
  chips.forEach(function(chip){
    chip.addEventListener('click', function(e){
      var tag = chip.getAttribute('data-pv-tag');
      if(!tag) return;
      e.preventDefault();
      active = tag;
      shown  = batch;
      chips.forEach(function(c){ c.setAttribute('aria-current', c === chip ? 'true' : 'false'); });
      paint();
      try{
        history.replaceState(null, '', chip.getAttribute('href'));
      }catch(err){}
      var bar = root.querySelector('.pv-filter');
      if(bar){
        var y = bar.getBoundingClientRect().top + window.pageYOffset - 4;
        if(window.pageYOffset > y) window.scrollTo({top:y, behavior:'smooth'});
      }
    });
  });

  paint();
})();